import { ComponentClass } from 'react';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
export { ComponentClass };
import { FolderPickerProps } from './components/Folders/FolderPicker';
import { TodoPanelProps } from './components/TodoPanel';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Todo", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Components
export let TodoPanel = createLazyComponent(lazyModule, m => m.TodoPanel);
export let FolderPicker = createLazyComponent(lazyModule, m => m.FolderPicker);

// Delayed Loaded Actions
export const LazyInitializeTodoPanel = new LazyAction(lazyModule, m => m.preloadTaskPanelData);
export const LazyInitializeQuickAdd = new LazyAction(lazyModule, m => m.initializeQuickAdd);

export { FolderPickerProps, TodoPanelProps };
